import ChangeCloseDate from './components/ChangeCloseDate';
import inviteNewProviders from './components/inviteNewProviders';

export default {
  request: {
    header: {
      title: 'Solicitud de Información',
      button1: 'Extender plazo de solicitud',
      button2: 'Invitar Proveedores',
    },
    body: {
      row1: {
        label1: 'Nº Solicitud',
        label2: 'Nombre Solicitud',
        label3: {
          title: 'Estado solicitud',
          option1: 'Publicada',
          option2: 'Cerrada',
        },
      },
      row2: {
        label1: 'Notas',
        label2: 'Fecha límite de respuesta',
        label3: {
          title: 'Adjunto',
          option1: 'Ver adjunto',
        },
      },
      row3: {
        tab1: 'Solicitudes',
        tab2: 'Respuestas',
        row: {
          label1: 'Proveedor',
          label2: 'Ítem',
          label3: {
            title: 'Registrado',
            option1: 'Si',
            option2: 'No',
          },
          label4: {
            title: 'Revisada',
            option1: 'Si',
            option2: 'No',
          },
          label5: {
            title: 'Respondida',
            option1: 'Sí',
            option2: 'No',
          },
        },
        tabpanel: {
          label1: 'Cuadro Comparativo - Precio y Disponibilidad',
          label2: 'Solicitud de Información',
          label3: 'Solicitado',
          label4: 'Proveedores',
          label5: 'Cuadro Comparativo - Respuestas Técnicas',
          label6: 'Solicitud de Información',
          label7: 'Proveedores',
        },
        gen_excel_button: ' Generar Excel ',
      },
      empty_answer: 'No se han encontrado respuestas para la solicitud de información.',
    },
    script: {
      components: {
        ...ChangeCloseDate,
        ...inviteNewProviders,
      },
      generateExcel: {
        title: 'Generar Excel',
        message: 'No hay datos para poder generar el archivo',
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/es-cl/buyer/request_information/request.js